var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order_box"},[_c('span',{staticClass:"order_number"},[_c('span',[_vm._v(_vm._s('#')+_vm._s(_vm.orderNo))]),_c('span',{staticClass:"time o ls3"},[_vm._v(_vm._s(_vm._f("timeFilters")(_vm.createdAt)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }